const schema = localStorage.getItem("schema")
export const basicFormData = () => ({
  inputData: {
    category_id: "",
    uom_id: "",
    name: "",
    code: "",
    descriptions: "",
    unit_cost: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "material_masters",
    schema:schema,
    "include": [
      {
        "model": "category_masters",
        "as": "category"
      },
      {
        "model": "uom_masters",
        "as": "uom"
      }
    ]
  };

  const navigatePage = { back: "/material-list" };

  const headerName = "Material";

  const validationType = "MaterialCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "material_masters",
      initialPayload: {
        modelName: "material_masters",
        schema:schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "material_masters",
    schema:schema,
    "include": [
      {
        "model": "category_masters",
        "as": "category"
      },
      {
        "model": "uom_masters",
        "as": "uom"
      }
    ]
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Category Name", value: "category.name" },
    { label: "UOM Name", value: "uom.name" },
    { label: "Material Name", value: "name" },
    { label: "Material Code", value: "code" },
    { label: "Unit Cost", value: "unit_cost" },
    { label: "Material Description", value: "descriptions" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/material-create",
    edit: "/material-create",
    view: "/material-view",
  };

  const searchfields = [
    "material_name",
    "category.name",
    "uom.name",
  ];

  const headerName = "Material";
  const endpoint = "/getRecords";
  const exportFileName = "MaterialData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "material_masters",
  schema:schema,
  include:[
    { module: "category_masters", moduleAs: "category" },
    { module: "uom_masters", moduleAs: "uom" }
  ],
  pagination: { page: 1, pageSize: 10000 },
};
